export default __webpack_public_path__ + "static/media/card_cover.ac7e88bf.webp";